module.exports = __webpack_public_path__ + "media/images/pic/lectors/magdalena-devault-6f1d50d1e8ced65893af16af8ea0df54.jpeg";